import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import styled from "@emotion/styled";
import {Box} from "@mui/material";

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiBackdrop-root': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        backdropFilter: 'blur(2px)',
    },
}));

const useConfirmationDialog = () => {
    const [open, setOpen] = useState(false);
    const [itemType, setItemType] = useState('');
    const [itemToDelete, setItemToDelete] = useState('');
    const [onConfirm, setOnConfirm] = useState(() => () => {});
    const [onCancel, setOnCancel] = useState(() => () => {});

    const showDialog = (type: string, item: string, confirmCallback: () => void, cancelCallback: () => void) => {
        setItemType(type);
        setItemToDelete(item);
        setOnConfirm(() => () => {
            confirmCallback();
            setOpen(false);
        });
        setOnCancel(() => () => {
            cancelCallback();
            setOpen(false);
        });
        setOpen(true);
    };

    const ConfirmationDialog = () => (
        <StyledDialog
            open={open}
            onClose={onCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Box sx={{display: 'flex', padding: '48px 71px', flexDirection: 'column', alignItems: 'center'}}>
                <DialogTitle sx={{fontSize: '18px', fontWeight: 800}} id="alert-dialog-title">Удаление {itemType}</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{fontSize: '18px', fontWeight: 400}} id="alert-dialog-description">
                        Вы уверены, что хотите удалить {`«${itemToDelete}»`}?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{gap: '8px', padding: '16px 24px', borderRadius: '8px'}}>
                    <Button sx={{width: '221px', height: '56px'}} onClick={onCancel} color="primary">
                        Отмена
                    </Button>
                    <Button sx={{backgroundColor: '#0573E4',
                        width: '221px', height: '56px',
                        color: 'white',
                        '&:hover': {
                            backgroundColor: 'rgba(34,126,220,0.86)'
                        },
                    }} onClick={onConfirm} color="primary" autoFocus>
                        Удалить
                    </Button>
                </DialogActions>
            </Box>
        </StyledDialog>
    );

    return { showDialog, ConfirmationDialog };
};

export default useConfirmationDialog;
